import { getCurrentUser } from '../localStorage'

const salesRepEmail = () => {
  if (process.env.NODE_ENV === 'development') return ''
  let user = getCurrentUser()
  if (user && user.email) return user.email
  return ''
}

const adminEmail = () => {
  if (process.env.NODE_ENV === 'development') return ''
  return 'admin@kimberfire.com'
}

const initialState = {
  modalOpen: false,
  completeSessionForm: {
    admin: {
      send: true,
      email: adminEmail()
    },
    salesRep: {
      send: true,
      email: salesRepEmail()
    },
    customer: {
      send: false,
      email: ''
    }
  },
  sendSummaryRequested: false,
  sendSummarySuccess: false,
  sendSummaryFail: false
}

export default function summary (state = initialState, action) {
  switch (action.type) {
    case 'OPEN_SESSION_MODAL':
      return {
        ...state,
        modalOpen: true,
        sendSummaryRequested: false,
        sendSummarySuccess: false,
        sendSummaryFail: false,
        completeSessionForm: {
          ...state.completeSessionForm,
          salesRep: {
            ...state.completeSessionForm.salesRep,
            email: salesRepEmail()
          },
          admin: {
            ...state.completeSessionForm.admin,
            email: adminEmail()
          }
        }
      }
    case 'CLOSE_SESSION_MODAL':
      return {
        ...state,
        modalOpen: false,
        sendSummaryRequested: false,
        sendSummarySuccess: false,
        sendSummaryFail: false
      }
    case 'COMPLETE_SESSION_FIELD_CHANGED':
      let {field, subfield, value} = action.value
      if (subfield === 'send') {
        value = !state.completeSessionForm[field][subfield]
      }
      return {
        ...state,
        completeSessionForm: {
          ...state.completeSessionForm,
          [field]: {
            ...state.completeSessionForm[field],
            [subfield]: value
          }
        }
      }
    case 'SET_CLIENT':
      return {
        ...state,
        completeSessionForm: {
          ...state.completeSessionForm,
          customer: {
            ...state.completeSessionForm.customer,
            email: action.value.email
          }
        }
      }
    case 'SEND_SUMMARY_REQUESTED':
      return {
        ...state,
        sendSummaryRequested: true,
        sendSummarySuccess: false,
        sendSummaryFail: false
      }
    case 'SEND_SUMMARY_SUCCESS':
      return {
        ...state,
        sendSummaryRequested: false,
        sendSummarySuccess: true,
        sendSummaryFail: false
      }
    case 'SEND_SUMMARY_FAIL':
      return {
        ...state,
        sendSummaryRequested: false,
        sendSummarySuccess: false,
        sendSummaryFail: true
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/summary.js